"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = _interopRequireDefault(require("@ux/button"));
var _text = _interopRequireDefault(require("@ux/text"));
var _savings = require("./utils/savings");
var _core = require("@linaria/core");
const potentialSavingsSectionText = "pl-p1s561n0";
const addSubtitle = "pl-a4l26zp";
const SavingsOutput = ({
  eid,
  title,
  years,
  subtitle,
  isMobile,
  buttonText,
  clickHandler,
  totalSavings = 0,
  monthlySavingsText = '',
  additionalSubtitle
}) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
  "data-cy": "savings-calculator-output-subtitle"
}, subtitle.replace('{years}', years)), /*#__PURE__*/_react.default.createElement("div", {
  className: "mt-2 bold"
}, /*#__PURE__*/_react.default.createElement(_text.default.p, {
  as: "title",
  size: isMobile ? 0 : 4,
  className: potentialSavingsSectionText,
  "data-cy": "savings-calculator-output-title"
}, title), /*#__PURE__*/_react.default.createElement(_text.default.p, {
  size: isMobile ? 0 : 4,
  className: potentialSavingsSectionText,
  "data-cy": "savings-calculator-saving"
}, (0, _savings.getFormattedSaving)(totalSavings))), /*#__PURE__*/_react.default.createElement(_text.default.p, {
  as: "paragraph",
  "data-cy": "savings-calculator-monthly-saving"
}, monthlySavingsText.replace('{savings}', (0, _savings.getMonthlySavings)(totalSavings, years))), !isMobile && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.default, {
  className: "rounded",
  design: "primary",
  text: buttonText,
  onClick: clickHandler,
  "data-cy": "savings-calculator-action-button",
  "data-eid": eid
}), /*#__PURE__*/_react.default.createElement(_text.default.p, {
  as: "paragraph",
  className: addSubtitle,
  "data-cy": "savings-calculator-additional-subtitle"
}, additionalSubtitle)));
SavingsOutput.propTypes = {
  eid: _propTypes.default.string,
  title: _propTypes.default.string,
  years: _propTypes.default.number,
  subtitle: _propTypes.default.string,
  isMobile: _propTypes.default.bool,
  buttonText: _propTypes.default.string,
  clickHandler: _propTypes.default.func,
  totalSavings: _propTypes.default.number,
  monthlySavingsText: _propTypes.default.string,
  additionalSubtitle: _propTypes.default.string
};
var _default = exports.default = SavingsOutput;